import { sortBy } from 'lodash-es';
import { idValues } from 'utils/arrays.js';
import { MEETING_STATUS_CLOSED } from '../constants.js';

function sortOrder(meeting) {
  const { assigned, slots } = meeting.details;
  return assigned ? slots[0].start : meeting.details.registerClose;
}

function getSortedMeetings(sets, studentId, from) {
  const hasStudent = (mt) => !studentId || mt.studentId === studentId;
  const afterFrom = (mt) => from && idValues(mt.blocks).some((b) => b.end > new Date(from));
  const meetings = idValues(sets)
    .filter((mtSet) => mtSet.status !== MEETING_STATUS_CLOSED || afterFrom(mtSet))
    .flatMap((mtSet) => idValues(mtSet.meetings).filter(hasStudent));
  return sortBy(meetings, sortOrder);
}

export default getSortedMeetings;
